import * as e from "react";
import { forwardRef as l } from "react";
const a = l(
  function(t, r) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: r,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement("rect", { fill: "#D70A0A", height: 18, rx: 2, width: 12, x: 7, y: 1 }),
      /* @__PURE__ */ e.createElement("rect", { fill: "#FFCA00", height: 18, rx: 2, width: 12, x: 4, y: 5 })
    );
  }
);
export {
  a as BetBuilderBadgeYellowCardsActive
};
